<div class="seedio-menu flex flex-col h-full">
  <span class="inline-flex items-center gap-1 p-4">
    <span class="text-xl font-semibold cursor-pointer" (click)="onHomePage()">
      Seedio
    </span>
  </span>

  <p-tieredMenu id="seedio-p-menu" [model]="setMenuItems">
    <ng-template #item let-item let-hasSubmenu="hasSubmenu">
      <a
        pRipple
        class="flex items-center p-tieredmenu-item-link my-1"
        [ngClass]="{
          'menu-item-active':
            item.routerLink && activeRoute === item.routerLink[0]
        }"
        [routerLink]="item.routerLink"
      >
        @if(item.icon){
        <svg-icon [src]="'assets/icons/' + item.icon" svgClass="w-6 h-6 icon" />

        } @else {
        <!-- <p-avatar
          image="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png"
          class="mr-2"
          shape="circle"
        /> -->

        <p-avatar
          [label]="item.title"
          styleClass="text-light-500 font-semibold"
          size="normal"
          shape="circle"
        />
        }

        <span class="ml-2">{{ item.label }}</span>

        @if (item.badge && item.badge !== '0') {
        <p-badge class="ml-auto" [value]="item.badge" />
        }

        <!--  -->
        @if (item.shortcut) {
        <span
          class="ml-auto border border-surface rounded bg-emphasis text-muted-color text-xs p-1"
        >
          {{ item.shortcut }}
        </span>
        }

        <!--  -->
        @if (hasSubmenu) {
        <i class="pi pi-angle-right ml-auto"></i>
        }
      </a>
    </ng-template>
  </p-tieredMenu>
</div>
